<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">{{$route.meta.title}}
      </template>
      <template slot="btn">
        <el-button size="medium"
                   v-has="'Edit Product'"
                   type="primary"
                   @click="openProductDialog()">{{$t('productDialog.AddProduct')}}</el-button>
        <el-button type="primary"
                   @click="exportExcel()"
                   size="medium">{{$t('task.ExportToFile')}}</el-button>
        <el-upload ref="uploadProductFile"
                   id="uploadProductFile"
                   action=""
                   :accept="importAccept"
                   :auto-upload="false"
                   style="display:none;"
                   :show-file-list="false"
                   :on-change="handleImport">
        </el-upload>
        <el-dropdown @command="importCommand"
                     v-has="'Edit Product'"
                     style="margin-left:10px">
          <el-button type="primary"
                     size="medium">{{$t('product.Import')}}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="Import"><i class="el-icon-upload2"></i> {{$t('product.Import')}}</el-dropdown-item>
            <el-dropdown-item command="ExportTemplate"><i class="el-icon-download"></i> {{$t('product.ExportTemplate')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template slot="search">
        <el-input v-model="condition.SKU"
                  :placeholder="$t('product.SearchSKU')"
                  size="mini"
                  clearable
                  @change="getProductList()"></el-input>
        <SortControl @sortList="sortList"
                     :orderBy="sortValue">
          <template slot="sort">
            <el-select size="mini"
                       @change="sort"
                       placeholder="Orderby"
                       v-model="sortBy">
              <el-option v-for="item in sortType"
                         :key="item.name"
                         :label="item.name"
                         :value="item.value"></el-option>
            </el-select>
          </template>
        </SortControl>
      </template>
    </sub-header>
    <div class="main">
      <div class="tool-btn">
        <el-button type="danger"
                   v-has="'Edit Product'"
                   size="mini"
                   :disabled="this.checkList.length < 1"
                   @click="batchDelete">{{$t('product.Delete')}}</el-button>
      </div>
      <div class="table-box">
        <myScroll style="width:100%;height:100%">
          <el-table ref="productTable"
                    size="small"
                    :data="list"
                    v-loading="loading"
                    :highlight-current-row="false"
                    @selection-change="handleSelectionChange"
                    style="position:absolute"
                    :default-sort="{prop: sortField, order: sortOrder}"
                    @sort-change="sortChange">
            <el-table-column type="selection"
                             width="55">
            </el-table-column>
            <el-table-column :label="$t('product.SKU')"
                             prop="SKU">
            </el-table-column>
            <el-table-column :label="$t('product.Trade')"
                             prop="Trade">
            </el-table-column>
            <el-table-column :label="$t('product.TotalQuantity')"
                             prop="Quantity">
            </el-table-column>
            <el-table-column :label="$t('product.Unit')"
                             prop="Unit">
              <template slot-scope="scope">
                {{scope.row.UnitStr}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('product.UnitCost')"
                             prop="Price">
              <template slot-scope="scope">
                {{scope.row.PriceStr}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('product.ContractAmount')"
                             prop="ContractAmount">
              <template slot-scope="scope">
                {{scope.row.ContractAmountStr}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('product.CreatedTime')"
                             prop="CreatedOn"
                             width="200">
              <template slot-scope="scope">
                {{scope.row.CreatedOn}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('product.Actions')"
                             width="120">
              <template slot-scope="scope">
                <el-tooltip class="item"
                            effect="dark"
                            :content="$t('product.Edit')"
                            placement="bottom">
                  <el-button circle
                             size="mini"
                             icon="el-icon-edit"
                             v-has="'Edit Product'"
                             @click="openProductDialog(scope.row.ProductId)"
                             type="success"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            :content="$t('product.Delete')"
                            placement="bottom">
                  <el-button circle
                             size="mini"
                             icon="el-icon-delete"
                             v-has="'Edit Product'"
                             @click="deleteProduct(scope.row.ProductId)"
                             type="danger"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </myScroll>
      </div>
      <page ref="pagination"
            :total="total"
            :PageSize="condition.PageSize"
            :PageIndex="condition.PageIndex"
            @handleCurrentChange="handleCurrentChange"></page>
    </div>
    <div>
      <Product-Dialog :showDialog="productDialog.show"
                      @closeDialog="closeProductDialog"
                      :id="productDialog.id"></Product-Dialog>
    </div>
  </div>
</template>

<script>
import { getProductList, deleteProducts, saveProducts, getByJobsiteSKUs, hasUsedInTask } from '@/api/config'
import { mapState } from 'vuex'
import ProductDialog from '@/components/product/productDialog.vue'
import SortControl from '@components/common/sortBtnList'
import XLSX from 'xlsx'

export default {
  data () {
    return {
      loading: false,
      user: [],
      filter: {
        showFilter: false
      },
      tab: 'All',
      checkList: [],
      list: [],
      total: 0,
      condition: {
        ProductId: null,
        SKU: null,
        Caption: null,
        JobsiteId: null,
        PageIndex: 1,
        PageSize: 20,
        GetRecycle: false,
        OrderBy: 'CreatedOn desc'
      },
      productDialog: {
        show: false,
        id: ''
      },
      selectedId: '',
      sortField: 'LastUpdatedOn',
      sortOrder: 'descending',
      importAccept: '.csv,.xlsx, application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet,application/vnd.ms-excel',
      importDatas: [],
      sortType: [
        {
          name: this.$t('product.SKU'),
          value: 'SKU'
        }, {
          name: this.$t('product.Trade'),
          value: 'Trade'
        }, {
          name: this.$t('product.TotalQuantity'),
          value: 'Quantity'
        }, {
          name: this.$t('product.Unit'),
          value: 'Unit'
        }, {
          name: this.$t('product.UnitCost'),
          value: 'Price'
        }, {
          name: this.$t('product.CreatedTime'),
          value: 'CreatedOn'
        }, {
          name: this.$t('task.UpdatedOn'),
          value: 'LastUpdatedOn'
        }],
      sortValue: 'desc',
      sortBy: 'CreatedOn'
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'productConditionOrderby'])
  },
  created () {
    this.setProductConditionOrderBy()
    this.getProductList()
  },
  mounted () {
  },
  watch: {
    jobsiteID () {
      this.condition.PageIndex = 1
      this.getProductList()
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.getProductList()
    },
    refresh () {
      this.condition.SKU = null
      this.condition.Caption = null
      this.$refs.reportTable.clearSort()
      this.getProductList()
    },
    sortList () {
      if (this.sortValue === 'asc') {
        this.sortValue = 'desc'
      } else {
        this.sortValue = 'asc'
      }
      this.sort()
    },
    sort () {
      this.condition.OrderBy = this.getProductConditionOrderBy()
      this.saveProductConditionOrderBy()
      this.getProductList()
    },
    getProductList () {
      this.condition.OrderBy = this.getProductConditionOrderBy()
      this.condition.JobsiteId = this.jobsiteID
      for (let i in this.condition) {
        if (!this.condition[i]) {
          this.condition[i] = null
        }
      }
      this.loading = true
      getProductList(this.condition).then(res => {
        this.list = res.Data
        this.list.forEach(ele => {
          ele.CreatedOn = this.$config.LocalTime(new Date(ele.CreatedOn))
          ele.Quantity = ele.Quantity.toFixed(2)
          ele.Price = ele.Price.toFixed(2)
          ele.ContractAmount = ele.Quantity * ele.Price
          ele.Quantity = this.$config.numberFormat(ele.Quantity)
          ele.UnitStr = this.$config.getNonM2ProductUnit(ele.Unit)
          ele.Price = this.$config.numberFormat(ele.Price)
          ele.PriceStr = '$' + ele.Price
          ele.ContractAmountStr = '$' + this.$config.numberFormat(ele.ContractAmount)
        })
        this.total = res.TotalCount
        this.loading = false
      })
    },
    async deleteProduct (id) {
      let allowDelete = await this.hasUsedInTask(id)
      if (!allowDelete) {
        this.$alert(this.$t('product.CannotDeleteProductUsedInTask'), this.$t('api.WARNING'))
        return
      }
      let params = []
      params.push(id)
      this.$confirm(this.$t('product.AreYouSureYouWantToDeleteThisProduct'), this.$t('product.TIPS'), {
        confirmButtonText: this.$t('product.Yes'),
        cancelButtonText: this.$t('product.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        deleteProducts(params).then(res => {
          this.$refs.pagination.handleDelete()
        })
      })
    },
    handleSelectionChange (val) {
      this.checkList = []
      val.forEach(res => {
        this.checkList.push(res.ProductId)
      })
    },
    async batchDelete () {
      if (this.checkList.length < 1) {
        this.$notify.info({
          title: this.$t('product.PleaseCheckOneProductAtLast')
        })
        return
      }
      this.$confirm(this.$t('product.AreYouSureYouWantToDeleteTheseProducts'), this.$t('product.TIPS'), {
        confirmButtonText: this.$t('product.Yes'),
        cancelButtonText: this.$t('product.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        deleteProducts(this.checkList).then(res => {
          if (res.UnUsedProductIds && res.UnUsedProductIds.length > 0) {
            this.$alert(this.$t('product.CannotDeleteSomeProductsUsedInTask', [res.UnUsedProductIds.length]), this.$t('product.TIPS'))
          }
          this.getProductList()
        })
      })
    },
    openProductDialog (id, name) {
      this.productDialog.show = true
      this.productDialog.id = id
    },
    closeProductDialog (val) {
      this.productDialog.show = false
      this.productDialog.id = ''
      if (val) {
        this.getProductList()
      }
    },
    sortChange (column) {
      this.sortField = column.prop
      this.sortOrder = column.order
      this.getProductList()
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: this.$t('welcome.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let condition = {
        ProductId: this.condition.ProductId,
        SKU: this.condition.SKU,
        Caption: this.condition.Caption,
        JobsiteId: this.jobsiteID,
        PageIndex: 1,
        PageSize: 100000,
        GetRecycle: false,
        OrderBy: this.condition.OrderBy
      }
      getProductList(condition).then(res => {
        res.Data.forEach(ele => {
          ele.CreatedOn = this.$config.LocalTime(new Date(ele.CreatedOn))
          ele.Quantity = ele.Quantity.toFixed(2)
          ele.Price = ele.Price.toFixed(2)
          ele.ContractAmount = ele.Quantity * ele.Price
          ele.Quantity = this.$config.numberFormat(ele.Quantity)
          ele.UnitStr = this.$config.getNonM2ProductUnit(ele.Unit)
          ele.Price = this.$config.numberFormat(ele.Price)
          ele.PriceStr = '$' + ele.Price
          ele.ContractAmountStr = '$' + this.$config.numberFormat(ele.ContractAmount)
        })
        require.ensure([], () => {
          // eslint-disable-next-line camelcase
          const { export_json_to_excel } = require('../../../excel/Export2Excel')
          const tHeader = [this.$t('product.SKU'), this.$t('product.Trade'), this.$t('product.TotalQuantity'), this.$t('product.Unit'), this.$t('product.UnitCost'), this.$t('product.ContractAmount'), this.$t('product.CreatedTime')]
          const filterVal = ['SKU', 'Trade', 'Quantity', 'UnitStr', 'PriceStr', 'ContractAmountStr', 'CreatedOn']
          const list = res.Data
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, this.$t('product.Products') + '_excel')
          loading.close()
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    importCommand (command) {
      if (command === 'ExportTemplate') {
        this.exportTemplate()
      } else {
        document.querySelector('#uploadProductFile .el-upload__input').click()
      }
    },
    exportTemplate () {
      const loading = this.$loading({
        lock: true,
        text: this.$t('welcome.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      require.ensure([], () => {
        // eslint-disable-next-line camelcase
        const { export_json_to_excel } = require('../../../excel/Export2Excel')
        const tHeader = ['SKU/Name', 'Trade', 'Total Quantity', 'Unit', 'Unit Cost']
        const filterVal = ['SKU', 'Trade', 'Quantity', 'Unit', 'UnitCost']
        const list = []
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, this.$t('product.ProductTemplate') + '_excel')
        loading.close()
      })
    },
    handleImport (event) {
      let that = this
      // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件（或原始数据缓冲区）的内容
      let fileReader = new FileReader()
      var file = event.raw
      // 回调函数
      fileReader.onload = ev => {
        try {
          let data = ev.target.result
          let workbook = XLSX.read(data, {
            type: 'binary'
          })
          // excel读取出的数据
          let excelData = XLSX.utils.sheet_to_json(
            workbook.Sheets[workbook.SheetNames[0]]
          )
          that.importDatas = []
          let skus = []
          excelData.forEach(item => {
            let obj = {}
            obj.SKU = item['SKU/Name']
            obj.Trade = item['Trade']
            let qty = item['Total Quantity']
            if (typeof (qty) === 'string' && qty && qty.length > 0) {
              obj.Quantity = this.$config.getFormatNumber(qty.replace(',', '').match(/\d+(.\d+)?/g)[0], 4)
            } else {
              obj.Quantity = qty || 0
            }
            obj.Unit = this.$config.getNonM2ProductUnitType(item['Unit']) || 0
            let unitCost = item['Unit Cost']
            if (typeof (unitCost) === 'string' && unitCost && unitCost.length > 0) {
              obj.Price = this.$config.getFormatNumber(unitCost.replace(',', '').match(/\d+(.\d+)?/g)[0], 4)
            } else {
              obj.Price = unitCost || 0
            }
            obj.JobsiteId = this.jobsiteID
            obj.Color = 0
            that.importDatas.push(obj)
            skus.push(obj.SKU)
          })
          that.checkByJobsiteSKUs(skus)
          document.getElementById('uploadProductFile').setAttribute('value', '')
        } catch (e) {
          console.log(e)
          this.$notify.closeAll()
          this.$notify({
            title: this.$t('api.WARNING'),
            message: this.$t('product.ImportFileFormat'),
            showClose: false
          })
          return false
        }
      }
      fileReader.readAsBinaryString(file)
    },
    checkByJobsiteSKUs (skus) {
      let condition = { JobsiteId: this.jobsiteID, SKUs: skus }
      getByJobsiteSKUs(condition).then(res => {
        if (!res || res.length === 0) {
          saveProducts(this.importDatas).then(res => {
            this.getProductList()
          })
        } else {
          let datas = []
          this.importDatas.forEach(iele => {
            let exist = res.find(f => f.SKU === iele.SKU)
            if (exist) {
              exist.Trade = iele.Trade
              exist.Quantity = iele.Quantity
              exist.Unit = iele.Unit
              exist.Price = iele.Price
              datas.push(exist)
            } else {
              datas.push(iele)
            }
          })
          if (datas.find(f => f.ProductId && f.ProductId.length === 36)) {
            this.$confirm(this.$t('product.AreYouSureYouWantToReplaceDuplicateSKUs'), this.$t('product.TIPS'), {
              confirmButtonText: this.$t('product.Yes'),
              cancelButtonText: this.$t('product.No'),
              closeOnClickModal: false,
              closeOnPressEscape: false,
              type: 'warning'
            }).then(() => {
              saveProducts(datas).then(s => {
                this.getProductList()
              })
            })
          } else {
            saveProducts(this.importDatas).then(s => {
              this.getProductList()
            })
          }
        }
      })
    },
    async hasUsedInTask (id) {
      let allowDelete = true
      await hasUsedInTask(id).then(res => {
        if (res === true) {
          allowDelete = false
        } else {
          allowDelete = true
        }
      })
      return allowDelete
    },
    getProductConditionOrderBySplit () {
      return ' '
    },
    getProductConditionOrderBy () {
      return this.sortBy + this.getProductConditionOrderBySplit() + this.sortValue
    },
    setProductConditionOrderBy () {
      let arr = this.productConditionOrderby.split(this.getProductConditionOrderBySplit())
      if (arr && arr.length === 2) {
        this.sortBy = arr[0]
        this.sortValue = arr[1]
      }
    },
    saveProductConditionOrderBy () {
      this.$store.commit('setProductConditionOrderby', this.condition.OrderBy)
    }
  },
  components: {
    ProductDialog,
    SortControl
  }
}
</script>

<style lang="scss">
.el-table .success-row {
  background: #f0f9eb;
}
</style>
<style scoped lang="scss">
.table-box {
  flex: 1;
  height: 0;
  margin: 0 8px;
  border: 1px solid #dcdfe6;
  .table-icon {
    width: 24px;
  }
  .row-name {
    line-height: 24px;
  }
  .row-link {
    cursor: pointer;
    width: 100%;
    height: 100%;
    color: #409eff;
    text-decoration: none;
  }
}
</style>
